import axios from "axios";
import { API_URL } from "../config/api";
import { notification } from "antd";
import {
  S3BackupConfig,
  S3BackupSegment,
  CreateS3BackupConfigRequest,
  UpdateS3BackupConfigRequest,
} from "./types";

export const getS3BackupConfigs = async (
  token: string,
): Promise<{ success: boolean; configs: S3BackupConfig[] } | null> => {
  try {
    const response = await axios({
      method: "get",
      url: `${API_URL}/s3backup`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    notification.error({
      message: "Error",
      description: "Failed to fetch backup configs",
    });
    console.error(error);
    return null;
  }
};

export const createS3BackupConfig = async (
  token: string,
  data: CreateS3BackupConfigRequest,
): Promise<{ success: boolean; config: S3BackupConfig } | null> => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/s3backup`,
      headers: { Authorization: `Bearer ${token}` },
      data,
    });
    return response.data;
  } catch (error: any) {
    const message =
      error?.response?.data?.message || "Failed to create backup config";
    notification.error({ message: "Error", description: message });
    console.error(error);
    return null;
  }
};

export const updateS3BackupConfig = async (
  token: string,
  id: string,
  data: UpdateS3BackupConfigRequest,
): Promise<{ success: boolean; config: S3BackupConfig } | null> => {
  try {
    const response = await axios({
      method: "put",
      url: `${API_URL}/s3backup/${id}`,
      headers: { Authorization: `Bearer ${token}` },
      data,
    });
    return response.data;
  } catch (error: any) {
    const message =
      error?.response?.data?.message || "Failed to update backup config";
    notification.error({ message: "Error", description: message });
    console.error(error);
    return null;
  }
};

export const deleteS3BackupConfig = async (
  token: string,
  id: string,
): Promise<{ success: boolean } | null> => {
  try {
    const response = await axios({
      method: "delete",
      url: `${API_URL}/s3backup/${id}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    notification.error({
      message: "Error",
      description: "Failed to delete backup config",
    });
    console.error(error);
    return null;
  }
};

export const resumeS3BackupConfig = async (
  token: string,
  id: string,
): Promise<{ success: boolean } | null> => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/s3backup/${id}/resume`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error: any) {
    const message =
      error?.response?.data?.message || "Failed to resume backup config";
    notification.error({ message: "Error", description: message });
    console.error(error);
    return null;
  }
};

export const getS3BackupSegments = async (
  token: string,
  configId: string,
): Promise<{ success: boolean; segments: S3BackupSegment[] } | null> => {
  try {
    const response = await axios({
      method: "get",
      url: `${API_URL}/s3backup/${configId}/segments`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    notification.error({
      message: "Error",
      description: "Failed to fetch backup segments",
    });
    console.error(error);
    return null;
  }
};
